import type { MediaStatus } from 'chromecast-caf-receiver/cast.framework.messages';

/**
 * Helper class to keep track of what `trackId`s have been transmitted to the sender.
 */
export class TrackIdTracker {
    private static _instance?: TrackIdTracker;
    private _trackIds: number[] = [];

    private constructor() {
        /* */
    }

    public static getInstance(): TrackIdTracker {
        return (this._instance ??= new TrackIdTracker());
    }

    public getTrackIds(): number[] {
        return this._trackIds;
    }

    public saveTrackIds(mediaStatus: MediaStatus): void {
        if (mediaStatus.media?.tracks) {
            this._trackIds = mediaStatus.media.tracks.map(({ trackId }) => trackId);
        }
    }
}
